export default __webpack_public_path__ + "static/media/Accouting-services-1.b6f20ef2.jpeg";